export const CRAWLER_EVENTS = {
  PROCESS_STARTED: 'PROCESS_STARTED',
  CONFIRM_PASSPHRASE: 'CONFIRM_PASSPHRASE',
  BANKID_APPROVED: 'BANKID_APPROVED',
  BANKID_TIMEOUT: 'BANKID_TIMEOUT',
  BANKID_ERROR: 'BANKID_ERROR',
  DOCUMENTS_DOWNLOADED: 'DOCUMENTS_DOWNLOADED',
  OFFER_DETAILS: 'OFFER_DETAILS',
  PROVIDED_DATA_NOT_VALID: 'PROVIDED_DATA_NOT_VALID',
  BANKID_SESSION_RUNNING: 'BANKID_SESSION_RUNNING',
  BANK_ID_FAILED_TO_CONNECT_WITH_USER_APP: 'BANK_ID_FAILED_TO_CONNECT_WITH_USER_APP',
  ERROR_HAPPENED: 'ERROR_HAPPENED',
  NO_SUCH_INSURANCE_TYPE_SUPPORTED: 'NO_SUCH_INSURANCE_TYPE_SUPPORTED',
  NO_DOCUMENTS_AVAILABLE: 'NO_DOCUMENTS_AVAILABLE',
  NO_CRAWLERS_FOR_SESSION_EXIST: 'NO_CRAWLERS_FOR_SESSION_EXIST',
  CONFIRM_USER_EMAIL_PHONE: 'CONFIRM_USER_EMAIL_PHONE',
  IF_CONFIRM_INFO: 'IF_CONFIRM_INFO',
  GJENSIDIGE_CONFIRM_INFO: 'GJENSIDIGE_CONFIRM_INFO',
  GJENSIDIGE_PERSONAL_DETAILS_CONFIRM_INFO: 'GJENSIDIGE_PERSONAL_DETAILS_CONFIRM_INFO',
  CONFIRM_USER_EMAIL_PHONE_NOT_SUCCESFULL: 'CONFIRM_USER_EMAIL_PHONE_NOT_SUCCESFULL',
  INVALID_DOB: 'INVALID_DOB',
  INVALID_PHONE: 'INVALID_PHONE',
  FRENDE_CONFIRM_INFO: 'FRENDE_CONFIRM_INFO',
  FRENDE_FEED_CONFIRM_INFO: 'FRENDE_FEED_CONFIRM_INFO',
  BLOCKED_USER: 'BLOCKED_USER',
  CAPTCHA_NOT_RESOLVED: 'CAPTCHA_NOT_RESOLVED',
  USER_IS_NOT_COMPANY_CUSTOMER: 'USER_IS_NOT_COMPANY_CUSTOMER',
  NO_ACTIVE_INSURANCES_FOUND: 'NO_ACTIVE_INSURANCES_FOUND',
  CRAWLED_FRONTEND_HAS_PROBLEM: 'CRAWLED_FRONTEND_HAS_PROBLEM',
  PDF2DATA_COMMUNICATION_FAILS: 'PDF2DATA_COMMUNICATION_FAILS',
  PDF2DATA_CAN_NOT_PARSE_PROVIDED_DOCUMENTS: 'PDF2DATA_CAN_NOT_PARSE_PROVIDED_DOCUMENTS'
};

// TODO: Moce to events statues
export const SESSIONS_STATUSES = {
  PARSING_COMPLETED: 'PARSING_COMPLETED',
  CRAWLING_FAILED: 'CRAWLING_FAILED',
  START_CRAWLING_SESSION: 'START_CRAWLING_SESSION',
  START_MANUAL_UPLOAD_SESSION: 'START_MANUAL_UPLOAD_SESSION',
  CRAWLING_COMPLETED: 'CRAWLING_COMPLETED',
  CRAWLING_HISTORY_COMPLETED: 'CRAWLING_HISTORY_COMPLETED',
  OFFER_DECLINED: 'OFFER_DECLINED',
  CREDIT_CHECK_FAILED: 'CREDIT_CHECK_FAILED',
  OFFER_ACCEPTED: 'OFFER_ACCEPTED',
  DUBLICATE_EUROBONUS_MEMBERSHIP_ID: 'DUBLICATE_EUROBONUS_MEMBERSHIP_ID',
  PROCESS_TIMEOUT: 'PROCESS_TIMEOUT',
  PARSING_FAILED: 'PARSING_FAILED',
  OFFER_VALIDATION_FAILED: 'OFFER_VALIDATION_FAILED',
  OFFER_PROVIDED: 'OFFER_PROVIDED',
  VALIDATION_SERVICE_FAILED: 'VALIDATION_SERVICE_FAILED',
  MANUAL_DELETE: 'MANUAL_DELETE',
  OFFER_VIEWED: 'OFFER_VIEWED',
  SENT_OFFER_REMINDER: 'SENT_OFFER_REMINDER',
  BATCH_OFFER_REMINDER: 'BATCH_OFFER_REMINDER',
  NAVIGATED_TO_MANUAL_UPLOAD: 'NAVIGATED_TO_MANUAL_UPLOAD',
  NAVIGATED_TO_BANKID: 'NAVIGATED_TO_BANKID',
  NAVIGATED_TO_SELECT_FLOW: 'NAVIGATED_TO_SELECT_FLOW',
  LINK_CLICKED: 'LINK_CLICKED',
  START_SESSION: 'START_SESSION',
  MANUAL_OFFER_PRODUCED: 'MANUAL_OFFER_PRODUCED',
  OFFER_DUPLICATE: 'OFFER_DUPLICATE',
  MANUAL_OFFER_DECLINED: 'MANUAL_OFFER_DECLINED',
  MANUAL_OFFER_ACCEPTED: 'MANUAL_OFFER_ACCEPTED',
  MANUAL_SALE_SESSION_INIT: 'MANUAL_SALE_SESSION_INIT',
  JSON_FLOW: 'JSON_FLOW',
  OFFER_GIVEN_MANUAL: 'OFFER_GIVEN_MANUAL',
  OFFER_BANKID_SSN_VERIFYED: 'OFFER_BANKID_SSN_VERIFYED',
  OFFER_BANKID_SSN_CANCELED: 'OFFER_BANKID_SSN_CANCELED',
  OFFER_BANKID_SSN_PROCESS_VEREFICATION_STARTED: 'OFFER_BANKID_SSN_PROCESS_VEREFICATION_STARTED',
};

export const SESSIONS_FLOW_TYPES = {
  BANK_ID: 'Bank id',
  MANUAL: 'Manual'
};

export const COMPLETE_STATUSES_MAP = {
  INVALID_USER_DATA: 'INVALID_USER_DATA',
  INTERNAL_EXCEPTION: 'INTERNAL_EXCEPTION',
  THIRD_PARTY_SERVICE_EXCEPTION: 'THIRD_PARTY_SERVICE_EXCEPTION',
  AUTOMATION_PROCESS_COMPLETED: 'AUTOMATION_PROCESS_COMPLETED',
  OFFER_ACCEPTED_BY_CLIENT: 'OFFER_ACCEPTED_BY_CLIENT',
  OFFER_DECLINED_BY_CLIENT: 'OFFER_DECLINED_BY_CLIENT',
  AUTOMATION_PROCESS_PROBLEM: 'AUTOMATION_PROCESS_PROBLEM',
  VALIDATION_PROCESS_COMPLETED: 'VALIDATION_PROCESS_COMPLETED',
  VALIDATION_PROCESS_PROBLEM: 'VALIDATION_PROCESS_PROBLEM',
  CLIENT_ACTION_PENDING: 'CLIENT_ACTION_PENDING',
  OFFER_DUPLICATE: 'OFFER_DUPLICATE'
};

export const SESSIONS_TABLE_DISPLAY_STATUSES = {
  GENERAL: [
    COMPLETE_STATUSES_MAP.AUTOMATION_PROCESS_COMPLETED,
    COMPLETE_STATUSES_MAP.OFFER_DECLINED_BY_CLIENT
  ],
  SUCCESS: [
    COMPLETE_STATUSES_MAP.OFFER_ACCEPTED_BY_CLIENT
  ],
  WARNING: [
    COMPLETE_STATUSES_MAP.INVALID_USER_DATA,
    COMPLETE_STATUSES_MAP.THIRD_PARTY_SERVICE_EXCEPTION
  ],
  DANGER: [
    COMPLETE_STATUSES_MAP.INTERNAL_EXCEPTION
  ],
  DANGER_LIGHT: [
    COMPLETE_STATUSES_MAP.AUTOMATION_PROCESS_PROBLEM
  ]
};
